"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = void 0;

var react_1 = require("@emotion/react");

var sizeStyles = {
  xlarge: react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 15px;\n    & > img {\n      max-width: 28px;\n      max-height: 28px;\n    }\n    & > span {\n      margin-left: 8px;\n    }\n  "]))),
  large: react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 15px;\n    & > img {\n      max-width: 24px;\n      max-height: 24px;\n    }\n    & > span {\n      margin-left: 8px;\n    }\n  "]))),
  medium: react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    & > img {\n      max-width: 16px;\n      max-height: 16px;\n    }\n    & > span {\n      margin-left: 2px;\n    }\n  "]))),
  small: react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 12px;\n    & > img {\n      max-width: 12px;\n      max-height: 12px;\n    }\n    & > span {\n      margin-left: 2px;\n    }\n  "])))
};

var wrapper = function wrapper(size) {
  return react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  color: var(--gray-700);\n  flex-direction: row;\n  align-items: center;\n  letter-spacing: -0.4px;\n  ", ";\n"])), sizeStyles[size]);
};

exports.wrapper = wrapper;